import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const Exchange = React.lazy(() => import("./Exchange/Exchange"));
const Trade = React.lazy(() => import("./Exchange/TradingChart/TradeChart"));
const AccountInfo = React.lazy(() => import("./Exchange/AccountInfo/AccountInfo"));
const NoAccess = React.lazy(() => import("./Exchange/NoAccess/NoAccess"));
// const AMM = React.lazy(() => import("./AMM/AMM"));
const Account = React.lazy(() => import("./Account/Account"));
const VIP = React.lazy(() => import("./Vip/Vip"));
const Widget = React.lazy(() => import("./Widget/Widget"));
const Affiliate = React.lazy(() => import("./Affiliate/Affiliate"));
const ConnectionPage = React.lazy(() => import("./Widget/WalletConnectionPage"));

export { Exchange, Trade, AccountInfo, Account, NoAccess, VIP, Widget, ConnectionPage };
